import { MacroNote } from '../../types/entities';

export interface MacroNoteState {
  loading: boolean;
  loaded: boolean;
  error?: string;
  notes: MacroNote[];
}

export const initialState: MacroNoteState = {
  loading: false,
  loaded: false,
  error: undefined,
  notes: []
};
